import Image from 'next/image';
import { useTranslation } from 'next-i18next/pages';
import { useState } from 'react';

import CookieConsentDrawer from '@/components/organisms/CookieConsentDrawer';
import LoginForm from '@/components/organisms/LoginForm';
import { SSOLoginForm } from '@/components/organisms/LoginForm/SSOForm';

import styles from './Login.module.css';

export default function Login() {
  const { t } = useTranslation('login');
  const [mode, setMode] = useState('password');

  return (
    <>
      <main className={styles.pageContainer}>
        <article className={styles.formContainer} aria-labelledby="login-heading" role="region">
          <Image
            alt="geoFluxus company logo"
            height={100}
            priority
            src="/images/logoVertical.png"
            unoptimized
            width={75}
          />
          <h1 className={styles.loginFormTitle} id="login-heading">
            {mode === 'sso' ? t('form.titleSSO') : t('form.title')}
          </h1>
          {mode == 'password' ? <LoginForm mode={mode} setMode={setMode} /> : <SSOLoginForm setMode={setMode} />}
        </article>
      </main>
      <CookieConsentDrawer />
    </>
  );
}
